angular
    .module('festzelt-os.components')
    .filter('objLength', [
        objLength
    ]);

function objLength() {
    return function (input) {
        return Object.keys(input).length;
    };
}



// WEBPACK FOOTER //
// ./src/app/components/filters/objLength.js